module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Song of Trusting the Heart")])])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "subtitle"
  }, [_vm._v("A C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LASSIC")]), _vm._v(" Z"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EN")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OEM")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FOR")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AILY")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EDITATION")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMARACK")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONG")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RT")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BY")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AN")]), _vm._v(" Z"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AREMBA")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d7892ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Title.vue
// module id = 63
// module chunks = 0